import { today } from 'AppReact';
import { addHours } from "date-fns";

export default {
    'MultiSelectHeader.HeaderWrapper.Icon': ({ }, outlet) => {
        outlet({ action: 'clear_all' });
    },
    'MultiSelectHeader.HeaderWrapper.ButtonsWrapper.AssignButtonWrapper.AssignButton': ({ isOpenAssignDropdown }, _, internalStateSetter) => {
        internalStateSetter({isOpenAssignDropdown: !isOpenAssignDropdown, isOpenScheduleDropdown: false });
    },
    'MultiSelectHeader.HeaderWrapper.ButtonsWrapper.AssignButtonWrapper.DropdownWrapper.ContentWrapper.Content.Tabs.TabLabelWrapper.Techs': ({ selectedItems }, outlet, internalStateSetter) => {
        internalStateSetter({selectedTab: 'techs'})
    },
    'MultiSelectHeader.HeaderWrapper.ButtonsWrapper.AssignButtonWrapper.DropdownWrapper.ContentWrapper.Content.Tabs.TabLabelWrapper.Vendors': ({ selectedItems }, outlet, internalStateSetter) => {
        internalStateSetter({selectedTab: 'vendors'})
    },
    'MultiSelectHeader.HeaderWrapper.ButtonsWrapper.AssignButtonWrapper.DropdownWrapper.ContentWrapper.Content.Tabs.TabLabelWrapper.Admins': ({ selectedItems }, outlet, internalStateSetter) => {
        internalStateSetter({selectedTab: 'admins'})
    },
    'MultiSelectHeader.HeaderWrapper.ButtonsWrapper.AssignButtonWrapper.DropdownWrapper.ContentWrapper.Content.Tabs.BackgroundWrapper.LeftSide.Search': ({ value }, outlet, internalStateSetter) => {
        internalStateSetter({searchVal: value})
    },
    'MultiSelectHeader.HeaderWrapper.ButtonsWrapper.AssignButtonWrapper.DropdownWrapper.ContentWrapper.Content.AssignTech': ({ selectedItems, tech }, outlet) => {
        outlet({
            action: 'assign',
            displayAction: 'assigned',
            params: {
                items: selectedItems.map(i => (
                    {make_ready_category_id: i.make_ready_category_id, card_id: i.card_id}
                )),
                tech_id: tech.id,
                admin_id: null,
                vendor_id: null,
            }
        })
    },
    'MultiSelectHeader.HeaderWrapper.ButtonsWrapper.AssignButtonWrapper.DropdownWrapper.ContentWrapper.Content.AssignVendor': ({ selectedItems, vendor }, outlet) => {
        outlet({
            action: 'assign',
            displayAction: 'assigned',
            params: {
                items: selectedItems.map(i => (
                    {make_ready_category_id: i.make_ready_category_id, card_id: i.card_id}
                )),
                tech_id: null,
                admin_id: null,
                vendor_id: vendor.id,
            }
        })
    },
    'MultiSelectHeader.HeaderWrapper.ButtonsWrapper.AssignButtonWrapper.DropdownWrapper.ContentWrapper.Content.AssignAdmin': ({ selectedItems, admin }, outlet, internalStateSetter) => {
        outlet({
            action: 'assign',
            displayAction: 'assigned',
            params: {
                items: selectedItems.map(i => (
                    {make_ready_category_id: i.make_ready_category_id, card_id: i.card_id}
                )),
                tech_id: null,
                admin_id: admin.id,
                vendor_id: null,
            }
        })
    },
    'MultiSelectHeader.HeaderWrapper.ButtonsWrapper.ScheduleButtonWrapper.ScheduleButton': ({ isOpenScheduleDropdown }, _, internalStateSetter) => {
        internalStateSetter({isOpenScheduleDropdown: !isOpenScheduleDropdown, isOpenAssignDropdown: false });
    },
    'MultiSelectHeader.HeaderWrapper.ButtonsWrapper.ScheduleButtonWrapper.DropdownWrapper.Calendar': ({ selectedItems, selectedDate }, outlet, internalStateSetter) => {
        outlet({
            action: 'schedule',
            displayAction: 'scheduled',
            params: {
                items: selectedItems.map(i => (
                    {make_ready_category_id: i.make_ready_category_id, card_id: i.card_id}
                )),
                scheduled: addHours(selectedDate, 12)
            }
        })
    },
    'MultiSelectHeader.HeaderWrapper.ButtonsWrapper.CompleteItemsButton': ({ selectedItems }, outlet) => {
        if (selectedItems?.find(i => i.is_complete)) {
            outlet({ displayAction: 'reopened', params: {
                    items: selectedItems.map(i => (
                        {make_ready_category_id: i.make_ready_category_id, card_id: i.card_id}
                    )),
                    status: null,
                    completed: null
                } });
        } else {
            outlet({ action: 'complete', displayAction: 'completed', params: {
                    items: selectedItems.map(i => (
                        {make_ready_category_id: i.make_ready_category_id, card_id: i.card_id}
                    )),
                    status: 'Admin Completed',
                    completed: today()
                } });
        }
    },
    'MultiSelectHeader.HeaderWrapper.ButtonsWrapper.ColumnButtonsWrapper.CompleteColumnButton': ({ selectedItems }, outlet) => {
        outlet({ action: 'complete', displayAction: 'completed', params: {
                items: selectedItems.map(i => (
                    {make_ready_category_id: i.make_ready_category_id, card_id: i.card_id}
                )),
                status: 'Admin Completed',
                completed: today()
            } });
    },
    'MultiSelectHeader.HeaderWrapper.ButtonsWrapper.ColumnButtonsWrapper.ReopenColumnButton': ({ selectedItems }, outlet) => {
        outlet({ displayAction: 'reopened', params: {
                items: selectedItems.map(i => (
                    {make_ready_category_id: i.make_ready_category_id, card_id: i.card_id}
                )),
                status: null,
                completed: null
            } });
    },
}
